import { QueryThuaDat } from 'lib/models/thongtinquyhoach.model';
import { ToaDo, ThuaDatEntity } from '../../../models';

export enum TabIndex {
  ToThua, ToaDo
}

export class SearchController {
  soToSoThua: Partial<QueryThuaDat> = {};
  tabIndex: TabIndex = TabIndex.ToThua;
  lstCoords: Array<ToaDo & { isValid?: boolean }> = [];
  constructor(
  ) {
  }

  /**
   * Xóa dòng tọa độ
   * @param  index: Số thứ tự cần xóa
   */
  handleRemoveCoords(index: number) {
    // nếu mảng chỉ còn một phần tử thì không cho xóa nữa
    if (this.lstCoords.length === 1) {
      return -1;
    }
    // kiểm tra index có vượt quá số lượng của mảng hay không?
    if (index < this.lstCoords.length) {
      this.lstCoords.splice(index, 1);

      // xóa phải backup một ô cho người dùng nhập
      const lastCoord = this.lstCoords[this.lstCoords.length - 1];
      if (lastCoord.toaDoX || lastCoord.toaDoY) {
        this.lstCoords.push({});
      }
      return index;
    }
  }

  async handleOnChangeInputCoord(value, index: number, type: 'toaDoX' | 'toaDoY') {
    // 1. kiểm tra index có vượt quá số lượng của mảng hay không?
    if (index > this.lstCoords.length - 1) {
      return;
    }

    const toaDo = { ...this.lstCoords[index] }; // lây tọa độ theo index
    if (type === 'toaDoX') {
      toaDo.toaDoX = value;
    } else if (type === 'toaDoY') {
      toaDo.toaDoY = value;
    }

    // 2. nếu index nằm ở vị trí cuối cùng
    if (index === this.lstCoords.length - 1) {
      // 2.1 nếu người dùng có nhập đầy đủ tọa độ X và Y thì mở rộng mảng
      if (toaDo.toaDoX !== undefined
        && toaDo.toaDoY !== undefined) {
        this.lstCoords.push({ isValid: false });
      }
    }

    // 3. nếu người dùng nhập không đúng định dạng sẽ làm mờ ô nhập liệu
    const isValid = this.isValidCoord(toaDo);
    this.lstCoords[index].isValid = isValid;
    // khi nhập tọa độ, kiểm tra xem tọa độ vừa nhập nó nằm trong ranh giới hành chính hay không
    return isValid;
  }

  isValidCoord(coord: ToaDo) {
    if (!coord.toaDoX && !coord.toaDoY) { return false; }

    const toaDoX = coord.toaDoX && coord.toaDoX.toString();
    const toaDoY = coord.toaDoY && coord.toaDoY.toString();

      // tọa độ X với số đầu là 5 hoặc 6, 6 số nguyên và nhiều nhất 3 chữ số thập phân
      const regexToaDoX = /^([11][0-9]{6})([.]([0-9]{1,3}))*$/;
      if (!regexToaDoX.test(toaDoX)) {
        return false;
      }
      // tọa độ Y với số đầu là 12, 7 số nguyên và nhiều nhất 3 chữ số thập phân
      const regexToaDoY = /^([4][0-9]{5})([.]([0-9]{1,3}))*$/;
    if (!regexToaDoY.test(toaDoY)) {
      return false;
    }

    return true;
  }

  isValid() {
    if (this.tabIndex === TabIndex.ToThua) {
      if (this.soToSoThua.maPhuongXa && this.soToSoThua.maQuanHuyen
        && this.soToSoThua.soThua && this.soToSoThua.soTo) {
        return true;
      } else { return false; }
    }
    // nếu là tọa độ thì các cặp tọa độ phải valid và ít nhất 3 cặp tọa độ
    else {
      return true;
    }
  }

  handleClear() {
    if (this.tabIndex === TabIndex.ToThua) {
      // reset form tờ thửa
      this.soToSoThua = {};
    } else if (this.tabIndex === TabIndex.ToaDo) {
      // reset form tọa độ
      this.lstCoords = [{}];
    }
  }
}
